import { render, staticRenderFns } from "./infoSenhas.vue?vue&type=template&id=21d9fab4"
import script from "./infoSenhas.vue?vue&type=script&lang=js"
export * from "./infoSenhas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports